import "./createChannelWizard.js";
import "./connectionTab.js";
import "./reviewTab.js";
import "./amazonConnectionDetails.js";
import "./details.js";
import "./configurationTab.js";
import "./createApiChannel.js";
import "./createEbayChannel.js";
import "./ebayConnectionsTab.js";
import "./ebayConfigurationsTab.js";
import "./ebayReviewTab.js";
import "./ebayDetails.js";
import "./walmartConnectionDetails.js";
import "./createWalmartChannel.js";
import "./walmartConnectionTab.js";
import "./walmartConfigurationTab.js";
import "./walmartReviewTab.js";


// WEBPACK FOOTER //
// ./src/pages/createChannel/index.js